import React, { useEffect } from "react";
import PDFObject from 'pdfobject';
import { useDispatch, useSelector } from "react-redux";
import { ddrmsViewFileDocsReceived, getDdrmsViewDocs, loadDdrmsViewDocs } from "../../store/documents";

const ViewFile = (props) => {
    const { controleId, comp } = props;

    const ddrmsViewDocsSelector = useSelector(getDdrmsViewDocs)
    const dispatch = useDispatch();

    useEffect(() => {
        if (comp?.ddrmsDoc > 0) {
            dispatch(loadDdrmsViewDocs(comp.ddrmsDoc));
        }
    }, []);

    useEffect(() => {
        // const handleContextmenu = e => {
        //     e.preventDefault()
        // }
        // document.addEventListener('contextmenu', handleContextmenu)
        // return function cleanup() {
        //     document.removeEventListener('contextmenu', handleContextmenu)
        // }
    }, [])

    useEffect(() => {
        if (ddrmsViewDocsSelector) {
            dispatch(ddrmsViewFileDocsReceived(null));
            const url = URL.createObjectURL(ddrmsViewDocsSelector);
            const options = {
                pdfOpenParams: {
                    toolbar: '0',  // Hide the toolbar
                    navpanes: '0', // Hide the left navigation pane
                    scrollbars: '0', // Hide the scrollbar
                    print: 'false',  // Disable the print button
                    download: 'false'  // Disable the print button
                }
            };
            // Embed the PDF with PDF.js and disable printing using the parameters
            PDFObject.embed(`${url}`, '#pdf-viewer', options);
            document.getElementById('pdf-viewer').style.width = '68%';
            document.getElementById('pdf-viewer').style.margin = 'auto';
        }

    }, [ddrmsViewDocsSelector])


    return <>
        {comp?.attributeDataTypes === "pdf" && <div oncontextmenu="return false;" id="pdf-viewer" style={{ height: "600px" }}>

        </div>}
    </>
}

export default ViewFile;